import { ApolloProvider } from '@apollo/client';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import './api';
import { apolloClient } from './api';
import './i18n';
import './index.css';
import { store } from './redux';
import { App } from './view/App';

ReactDOM.render(
    <ApolloProvider client={apolloClient}>
        <Provider store={store}>
            <BrowserRouter>
                <React.Suspense fallback=''>
                    <App />
                </React.Suspense>
            </BrowserRouter>
        </Provider>
    </ApolloProvider>,
    document.getElementById('root'),
);
